import {AircraftTypeResponse, FlightCalculationRequestLeg} from "../../api/model/activity-flight";
import {HotelClass, HotelResponse} from "../../api/model/activity-hotel";

/**
 * Converts a UI aircraft type object to an API aircraft type identifier.
 *
 * This function takes an aircraft type object returned from the UI layer and extracts
 * the corresponding IATA code to be used in the API request. If the provided aircraft
 * type is null, the function returns null.
 *
 * @function convertUiAircraftTypeToApiAircraftType
 * @param {AircraftTypeResponse | null} aircraftType - The aircraft type object from the UI, or null if not available.
 * @returns {FlightCalculationRequestLeg['aircraftType']} The IATA code of the aircraft type, or null if the input is null.
 */
export const convertUiAircraftTypeToApiAircraftType = (aircraftType: AircraftTypeResponse | null): FlightCalculationRequestLeg['aircraftType'] => {
    if (aircraftType) return aircraftType.iata
    return null;
}

/**
 * Converts a hotel class enumeration value to its corresponding travel class string.
 *
 * @param {HotelClass} hotelClass - The hotel class enumeration value to be converted.
 * @returns {HotelResponse['stars'] | null} A string representing the travel class corresponding to the hotel class, or undefined if the hotel class is invalid.
 */
export const convertEnumHotelClassToStringTravelClass = (hotelClass: HotelClass): HotelResponse['stars'] | null => {
    switch (hotelClass) {
        case HotelClass.zero:
            return 'ZERO'
        case HotelClass.one:
            return 'ONE'
        case HotelClass.two:
            return 'TWO'
        case HotelClass.three:
            return "THREE"
        case HotelClass.four:
            return "FOUR"
        case HotelClass.five:
            return "FIVE"
        default:
            hotelClass satisfies never
    }
    return null
}
